export default "__VITE_ASSET__eb42c168__"